import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, get, request } from "@insite/client-framework/Services/ApiService";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";

export interface BatchGetProductsApiParameter extends ApiParameter {
    extendedNames: string[];
}

export interface BatchGetProductsByCustomVariantApiParameter extends ApiParameter {
    variantType: string | null;
    parentProductId: string | null;
    attributeType: string | null;
}

export interface ProductModelByVariant {
    products: ProductDto[];
    attributesValueByProduct: AttributeValueByProduct[];
    attributeTypeLabel: string;
}
export interface AttributeValueByProduct {
    productId: string;
    attributeTypeId: string;
    id: string;
    value: string;
    sortOrder: number;
}

const productsUrl = "/api/v1/productsExtended";

export function batchGetProductsExtended(parameter: BatchGetProductsApiParameter) {
    return request<(ProductDto | null)[]>(
        `${productsUrl}/batchget`,
        "POST",
        { "Content-Type": "application/json" },
        JSON.stringify({ extendedNames: parameter.extendedNames }),
    );
}

export async function batchGetProductsByCustomVariant(
    parameter: BatchGetProductsByCustomVariantApiParameter,
): Promise<ProductModelByVariant | null> {
    try {
        const resultModel = await get<ProductModelByVariant | null>(
            `${productsUrl}/GetByVariantType?variantType=${parameter.variantType}&parentProductId=${parameter.parentProductId}&attributeType=${parameter.attributeType}`,
        );
        return resultModel;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return null;
        }
        throw error;
    }
}
